import ActionNames from '../../actions/names';
import Immutable from 'seamless-immutable';

const initialState = Immutable({
  loading: true,
  data: [],
  error: null,
});

function brandAdoption(state = initialState, action) {
  switch(action.type) {
    case ActionNames.REQUEST_BRAND_ADOPTION_DATA:
      return state.merge({loading: true, data: []});
    case ActionNames.RECEIVE_BRAND_ADOPTION_DATA:
      return state.merge({loading: false, data: action.data.data});
    case ActionNames.FAILURE_BRAND_ADOPTION_DATA:
      return state.merge({loading: false, error: action.error, data: []});
    default:
      return state;
  }
}

export default brandAdoption;
